import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { dynamicElementsIconKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicElementsTooltipDirective } from '@epicuro-next/dynamic-elements/dynamic-tooltip';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@DynamicComponentRegister(dynamicElementsIconKey)
@Component({
  selector: 'epc-dynamic-elements-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
  host: {
    '[attr.title]': 'title',
  },
  hostDirectives: [
    {
      directive: DynamicElementsTooltipDirective,
      // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
      inputs: ['tooltip', 'tooltipPlacement'],
    },
  ],
  standalone: false,
})
export class DynamicElementsIconComponent extends FaIconComponent {
  @HostBinding('class')
  public iconClass = 'ng-fa-icon';
}
